<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "hide-header": "",
        "hide-footer": "",
        id: "resend-email",
        centered: "",
        size: "sm",
        "no-close-on-backdrop": true,
      },
      model: {
        value: _vm.resendEmail,
        callback: function ($$v) {
          _vm.resendEmail = $$v
        },
        expression: "resendEmail",
      },
    },
    [
      _c("div", { staticClass: "modal-ui" }, [
        _c("div", { staticClass: "rc-modal-title" }, [
          _vm._v(_vm._s(_vm.$t("Resend-email"))),
        ]),
        _c(
          "div",
          { staticClass: "email-desc" },
          [
            _vm._v(" " + _vm._s(_vm.$t("resend-desc")) + " "),
            _c("b-link", { attrs: { href: _vm.userEmail, target: "_blank" } }, [
              _vm._v(_vm._s(_vm.userEmail)),
            ]),
            _vm._v(" " + _vm._s(_vm.$t("again")) + " "),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "text-center" },
          [
            _c(
              "b-button",
              {
                staticClass: "mt-2",
                attrs: { variant: "primary" },
                on: { click: _vm.sendAgain },
              },
              [
                _c("span", { staticClass: "mr-25 align-middle" }, [
                  _vm._v(_vm._s(_vm.$t("send-again"))),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "p",
          { staticClass: "text-center mt-1" },
          [
            _c(
              "b-link",
              { on: { click: _vm.backToLogin } },
              [
                _c("feather-icon", { attrs: { icon: "ChevronLeftIcon" } }),
                _vm._v(" " + _vm._s(_vm.$t("forgot.backToLogin")) + " "),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/ResendVerifyLink.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import * as vuex from 'vuex';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





export default ({
  render,
  staticRenderFns,
  components: {
    BButton: bootstrapvue["BButton"],
    BModal: bootstrapvue["BModal"],
    BLink: bootstrapvue["BLink"]
  },
  data() {
    return {
      isLoading: false,
      userEmail: ""
    };
  },
  computed: {
    ...vuex.mapState("user", ["user"])
  },
  watch: {
    user(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.userEmail = this.user.email;
      }
    }
  },
  mounted() {
    this.userEmail = this.user.email;
  },
  methods: {
    backToLogin() {
      try {
        new libs_api_api().logout();
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async sendAgain() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "post",
          url: "auth/resendEmailVerificationLink"
        }, {
          token: localStorage.getItem("accessToken")
        }, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus === "SUCCESS") {
          // this.toggleResendEmailPop(false);
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.message,
              icon: "EditIcon",
              variant: "success"
            }
          });
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    }
  },
  props: {
    resendEmail: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    toggleResendEmailPop: {
      type: Function,
      isRequired: true,
      default: () => {}
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/ResendVerifyLink.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

